import { showHttpError } from '@calendly/alert'

import { rootApi } from 'root-api'

import { setConnectedIntegrations } from './slice'

export const api = rootApi.injectEndpoints({
  endpoints: (build) => ({
    getConnectedIntegrations: build.query({
      query: () => ({ url: '/api/integrations/connected_integrations' }),
      providesTags: ['ConnectedIntegrations'],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          dispatch(setConnectedIntegrations(data))
        } catch (e) {
          dispatch(showHttpError(e.error))
        }
      },
    }),
  })
})

export const { useGetConnectedIntegrationsQuery } = api
